import { languagesSlice } from "./languagesSlice";
import * as actions from "./languagesActions";
import * as selectors from "./languagesSelectors";

export { actions };
export { selectors };
export default languagesSlice.reducer;